import React, { useEffect, useRef, useState } from 'react'
import style from "css/sign.module.css"
import { Button, ConfigProvider, Input, Modal } from 'antd';
import modalStyle from "css/modal.module.css";
import axios from 'axios';
import OpenModal from 'function/openModal';
import { useTranslation } from 'react-i18next';

function UpdatePassword({ openUpdatePassword }) {
    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState({
        newValue: "",
        reValue: ""
    });

    const { t } = useTranslation();

    const reRef = useRef();

    useEffect(() => {
        return () => setLoading(false);
    }, [])

    const update = () => {
        if (password.newValue !== password.reValue) {
            Modal.destroyAll();

            const props = {
                type: "info",
                title: t("LABEL.TITLE.RESET_PASSWORD"),
                content: t("MESSAGE.PASSWORD_MISMATCH"),
                okText: t("common.button.ok"),
                img: process.env.REACT_APP_CLIENT_URL + "img/common/modal_icon_green.png",
                btnEvent: () => openUpdatePassword()
            }
            OpenModal(props);
        } else {
            const email = new URL(window.location.href).searchParams.get("email");
            const data = {
                password: password.newValue,
                email: email
            }

            axios.put("/user/password", data)
                .then(
                    res => {
                        if (res.status === 200) {
                            Modal.destroyAll();

                            const props = {
                                type: "info",
                                title: t("LABEL.TITLE.RESET_PASSWORD"),
                                content: t("MESSAGE.PW_CHANGE_SUCCESS"),
                                okText: t("common.button.ok"),
                                img: process.env.REACT_APP_CLIENT_URL + "img/common/modal_icon_green.png",
                                btnEvent: () => { }
                            }
                            OpenModal(props);
                        }
                    }
                )
                .catch(
                    err => {
                        Modal.destroyAll();

                        const props = {
                            type: "info",
                            title: t("LABEL.TITLE.RESET_PASSWORD"),
                            content: t("user." + err.response.data),
                            okText: t("common.button.ok"),
                            img: process.env.REACT_APP_CLIENT_URL + "img/common/modal_icon_green.png",
                            btnEvent: () => openUpdatePassword()
                        }
                        OpenModal(props);
                    }
                )
        }
    }

    return (
        <section className={style.password_container}>
            <article className={style.password_comment}>
                <p>{t("LABEL.TITLE.RESET_PW")}</p>
            </article>


            <ConfigProvider
                theme={{
                    components: {
                        Input: {
                            colorPrimaryHover: '#1cb691',
                        },
                        Button: {
                            colorBgContainerDisabled: '#c0c0c0',
                            colorTextDisabled: 'white',
                            colorPrimaryHover: 'black',
                            colorFillSecondary: 'black',
                        }
                    }
                }}
            >
                <div className={style.password_input_container}>
                    <Input
                        type='password'
                        className={style.item_input}
                        placeholder={t("PLACEHOLDER.INPUT.NEW_PW")}
                        onChange={e => setPassword({ ...password, newValue: e.target.value })}
                        onPressEnter={
                            () => reRef.current.focus()
                        }
                    />
                    <Input
                        type='password'
                        className={style.item_input}
                        placeholder={t("PLACEHOLDER.INPUT.CONFIRM_NEW_PW")}
                        onChange={e => setPassword({ ...password, reValue: e.target.value })}
                        ref={reRef}
                        onPressEnter={
                            () => {
                                if (password.newValue.length > 0 && password.reValue.length > 0) {
                                    update();
                                }
                            }
                        }
                    />
                </div>
                <Button
                    className={modalStyle.green_full_btn}
                    onClick={() => update()}
                    loading={loading}
                    disabled={password.newValue.length < 1 || password.reValue.length < 1}
                >
                    {t("BTG.CHANGE_PASSWORD")}
                </Button>
            </ConfigProvider>
        </section>
    )
}

export default UpdatePassword
